<template>
<v-row wrap>

    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card v-if="selectuser != null">
            <v-card-title>
                <span class="headline">Edit Item</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Name*" v-model="name" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field label="Serial*" v-model="serial"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-select :items="typeitem" v-model="group" item-text="text" item-value="value" label="Group*"></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" v-if="booking_id != null">
                            <v-text-field disabled label="Booking id*" v-model="booking_id"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-if="booking_id != null">
                            <v-text-field disabled label="Room*" v-model="room"></v-text-field>
                        </v-col>

                    </v-row>
                </v-container>
                <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>

                <v-btn color="red" v-if='!deleteuserbtn &&  booking_id != null && !returnproduct' dark @click="returnproduct =true">
                    Return products
                </v-btn>
                <v-btn color="red" text v-if='returnproduct' dark @click="returnproduct = false">
                    cancel
                </v-btn>
                <v-btn color="red" v-if='returnproduct' dark @click="conreturnproduct">
                    confirm
                </v-btn>

                <v-btn color="red" v-if='!deleteuserbtn && selectuser.booking_id == null' dark @click="deleteuserbtn = true">
                    DELETE equipment
                </v-btn>
                <v-btn color="red" text v-if='deleteuserbtn' dark @click="deleteuserbtn = false">
                    cancel
                </v-btn>
                <v-btn color="red" v-if='deleteuserbtn' dark @click="deleteequipment">
                    confirm
                </v-btn>
                <v-spacer></v-spacer>


                <v-btn color="blue darken-1" text @click="closedialog">
                    Close
                </v-btn>
                <v-btn color="blue darken-1" v-if='!adduserprofile' text @click="updateitem">
                    Save
                </v-btn>
                <v-btn color="blue darken-1" v-if='adduserprofile' text @click="add">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-col cols="12">
        <v-row justify="center" style="padding-top:5vh">

            <v-col cols="12">
                <div class="text-start">
                    <!-- <v-btn rounded color="primary" dark>
                        <v-icon right dark>
                            mdi-cloud-upload
                        </v-icon>Add user
                    </v-btn> -->

                    <v-btn tile rounded color="success" @click="additem">
                        <v-icon left>
                            mdi-plus-circle
                        </v-icon>
                        Add Item
                    </v-btn>
                </div>
            </v-col>
            <v-card>

                <v-card-title v-if="data.showtable" width="100%">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="data.showtable" width="500"  :headers="header" :items="data.datatable" ::items-per-page="6" 
                :footer-props="{ 'items-per-page-options': [6,9]}" :search="search" class="elevation-1 ">

                    <template v-slot:item.timelimit="{ item }">
                        <v-chip v-if="item.timelimit === '99:99:99'" color="light-green darken-1" dark>
                            Unlimited
                        </v-chip>
                        <v-chip v-if="item.timelimit !== '99:99:99'" color="deep-orange darken-3" dark>
                            {{ item.timelimit }}
                        </v-chip>
                    </template>

                    <template v-slot:item.etc="{ item }">
                        <!-- <v-menu > -->
                        <v-btn fab icon small @click="editItem(item)">
                            <v-icon color="light-blue accent-4">
                                mdi-dots-horizontal
                            </v-icon>
                        </v-btn>

                        <!-- </v-menu> -->
                    </template>

                </v-data-table>
            </v-card>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data() {
        return {
            adduserprofile: false,
            deleteuserbtn: false,
            selectuser: null,
            dialog: false,
            search: '',
            returnproduct: false,

            name: null,
            serial: null,
            group: null,
            booking_id: null,
            room: null,

            dialogtext: null,

            typeitem: [{
                    text: 'Video Conference',
                    value: '1'
                },
                {
                    text: 'Interactive Board',
                    value: '2'
                },
                {
                    text: 'Microphone',
                    value: '3'
                },
                {
                    text: 'Wireless Sharing',
                    value: '4'
                },
                {
                    text: 'tablate',
                    value: '5'
                },
                {
                    text: 'lcd',
                    value: '6'
                },
            ],

            header: [
                // {
                //     "text": "Email",
                //     "value": "equipment_id",
                //     width: '120',
                // },
                // {
                //     "text": "Firstname",
                //     "value": "equipment_code",
                //     width: '200',
                // },
                {
                    "text": "Name",
                    "value": "equipment_name",
                    width: '150',
                },
                {
                    "text": "serial",
                    "value": "equipment_serial",
                    width: '120',
                },
                {
                    "text": "Last update",
                    "value": "equipment_update_date",
                    width: '200',
                    align: 'center'
                    // align: 'center'
                },
                {
                    "text": "Type",
                    "value": "equipments_type",
                    width: '100',
                    sortable: false
                },
                {
                    "text": "Booking id",
                    "value": "booking_id",
                    width: '100',
                    sortable: false
                },
                {
                    "text": "Group",
                    "value": "group_name",
                    width: '100',
                    sortable: false
                },
                {
                    "text": "Room",
                    "value": "room",
                    width: '150',
                    sortable: false
                },
                {
                    "text": "Action",
                    "value": "etc",
                    width: '100',
                    sortable: false
                }
            ],
        }
    },

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
        },
        ...mapState('datas', {
            data: 'data'
        }),
    },

    created() {
        // this.$store.dispatch("datas/getbooking")
        this.$store.dispatch("datas/getlistequipment")
    },

    methods: {
        editItem(item) {
            this.selectuser = item
            this.dialog = true

            this.name = item.equipment_name
            this.serial = item.equipment_serial
            this.group = item.group_id
            this.booking_id = item.booking_id
            this.room = item.room
            // console.log(this.booking_id)
        },
        confirm() {
            let payload = new FormData()
            let status
            if (this.booking.booking_status == "booking") {
                status = "cancel"
            } else if (this.booking.booking_status == "cancel") {
                status = "booking"
            }
            payload.append('booking_id', this.booking.booking_id)
            payload.append('status', status)
            this.$store.dispatch("datas/changebookingstatus", payload)
            // console.log(this.booking)
            this.dialog = false
        },
        updateitem() {
            // console.log(this.user)
            let payload = new FormData()

            payload.append('equipment_name', this.name)
            payload.append('equipment_serial', this.serial)
            payload.append('group_id', this.group)
            payload.append('equipment_id', this.selectuser['equipment_id'])
            payload.append('equipment_code', this.selectuser['equipment_code'])
            console.log(this.selectuser['equipment_code'])

            this.$store.dispatch("datas/changeequipment", payload)

            this.dialog = false
            this.deleteuserbtn = false
            this.returnproduct = false

            this.selectuser = []
            this.name = null
            this.serial = null
            this.group = null
            this.booking_id = null
            this.room = null
        },
        deleteequipment() {
            console.log("delete")
            let payload = new FormData()
            payload.append('equipment_id', this.selectuser['equipment_id'])
            this.$store.dispatch("datas/deleteequipment", payload)
            this.dialog = false
            this.selectuser = []
            this.deleteuserbtn = false
        },
        additem() {
            this.selectuser = []
            this.name = null
            this.serial = null
            this.group = null
            this.booking_id = null
            this.room = null
            this.dialog = true
            this.adduserprofile = true

        },
        add() {
            this.adduserprofile = false
            let payload = new FormData()
            payload.append('equipment_name', this.name)
            payload.append('equipment_serial', this.serial)
            payload.append('group_id', this.group)
            // console.log(this.group)
            this.$store.dispatch("datas/additem", payload)
            this.dialog = false
        },
        closedialog(){
            this.dialog = false
            this.deleteuserbtn = false
            this.returnproduct = false
        },
        conreturnproduct(){
            let payload = new FormData()
            payload.append('equipment_name', this.name)
            payload.append('equipment_serial', this.serial)
            payload.append('group_id', this.group)
            payload.append('equipment_id', this.selectuser['equipment_id'])
            payload.append('equipment_code', 'null')
            // console.log(this.group)
            this.$store.dispatch("datas/changeequipment", payload)

            this.dialog = false
            this.deleteuserbtn = false
            this.returnproduct = false

            this.selectuser = []
            this.name = null
            this.serial = null
            this.group = null
            this.booking_id = null
            this.room = null
        }

    },
}
</script>

<style>

    </style>
